import PaymentHistoryComp from "../../components/history/PaymentHistoryComp";

function PaymentHistory() {

  return (
    <PaymentHistoryComp/>
  );
}

export default PaymentHistory;